import {CometBorder} from "./CometBorder";

export const Button = () => {
    return (<></>)
}

Button.CometBorder = CometBorder